import { MenuItem } from './menu.model'
import { AppRoutesNS } from 'src/app/app-routes.namespace'
export const initialMenu: MenuItem[] = [
  {
    translateString: 'general.home',
    link: AppRoutesNS.Home.HOME,
    icon: 'house',
    restrictToRoles: [],
    dataTestId: 'primary-nav-bar-menu-item-home'
  },
  {
    translateString: 'general.shop',
    link: AppRoutesNS.Shop.SHOP,
    icon: 'shopping-cart',
    restrictToRoles: [],
    dataTestId: 'primary-nav-bar-menu-item-shop'
  },
  {
    translateString: 'tagModule.activities',
    link: AppRoutesNS.Booking.ACTIVITIES,
    icon: 'calendar-alt',
    restrictToRoles: [],
    dataTestId: 'primary-nav-bar-menu-item-activities'
  },
  {
    translateString: 'rentalModule.rent',
    link: AppRoutesNS.Booking.RENT,
    icon: 'court-sport',
    restrictToRoles: [],
    dataTestId: 'primary-nav-bar-menu-item-rent'
  },
  {
    translateString: 'general.overview',
    link: AppRoutesNS.Overview.OVERVIEW,
    icon: 'eye',
    restrictToRoles: [],
    dataTestId: 'primary-nav-bar-menu-item-overview'
  },
  {
    translateString: 'bookingModule.myBookings',
    link: AppRoutesNS.Upcoming.UPCOMING_BOOKINGS,
    navBarName: 'upcoming',
    icon: 'alarm-clock',
    restrictToRoles: [],
    dataTestId: 'primary-nav-bar-menu-item-upcoming'
  },
  {
    translateString: 'myWorkModule.myWork',
    link: AppRoutesNS.MyWork.MY_WORK,
    icon: 'laptop-house', //table
    restrictToRoles: [],
    dataTestId: 'primary-nav-bar-menu-item-my-work'
  },
  {
    translateString: 'competitionModule.competitions',
    link: AppRoutesNS.Competitions.COMPETITIONS,
    icon: 'award',
    restrictToRoles: [],
    dataTestId: 'primary-nav-bar-menu-item-competitions'
  }

  // TODO activate when module is done
  // {
  //   translateString: 'general.book',
  //   link: '/booking/claim',
  //   icon: 'calendar',
  //   restrictToRoles: []
  // },
  // {
  //   translateString: 'general.schedule',
  //   link: '/booking/open',
  //   icon: 'calendar',
  //   restrictToRoles: []
  // },
  // {
  //   translateString: 'general.enrollment',
  //   link: '/guarantees',
  //   icon: 'edit',
  //   restrictToRoles: []
  // },
  // {
  //   translateString: "general.news",
  //   link: "/news",
  //   icon: "info",
  //   restrictToRoles: []
  // },
  // {
  //   translateString: "general.chat",
  //   link: "/chat",
  //   icon: "message-square",
  //   restrictToRoles: []
  // },
  // {
  //   translateString: "general.contact",
  //   link: "/contact",
  //   icon: "file-text",
  //   restrictToRoles: []
  // },
  // {
  //   translateString: 'surveyModule.survey',
  //   link: '/surveys',
  //   icon: 'tag',
  //   restrictToRoles: []
  // },
]
